module.exports = __webpack_public_path__ + "img/green-city.419b730c.gif";